module.exports = __webpack_public_path__ + "img/Vectorcustomer.d2f898cc.svg";